// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateShipTo as updateShipToApi } from "@insite/client-framework/Services/CustomersService";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Data/ShipTos/Handlers/UpdateShipTo";

export const XngSendDataToApi: any = async (props: any) => {
    props.apiResult = await updateShipToApi(props.apiParameter);
    delete props.apiResult?.validation;
};

replaceInChain(chain, SendDataToApi, XngSendDataToApi);
